import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,

    "& .item": {
      minWidth: "83px",
    },
  },
}));

export default useStyles;
